export default "__VITE_ASSET__CQlGcj_e__"